$(function () {
  $("#root").css("zoom", "normal");
  let scale = document.body.clientWidth / 1080;
  $("#root").css("zoom", scale);

  window.addEventListener(
    "resize",
    (function () {
      var timer;
      return function () {
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          $("#root").css("zoom", "normal");
          let scale = document.body.clientWidth / 1080;
          $("#root").css("zoom", scale);
        }, 100);
      };
    })()
  );
});

function lazyLoadImages() {
  // 懒加载
  const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
  const config = {
    rootMargin: "0px 0px 1300px 0px",
    threshold: 0,
  };

  const lazyLoadObserver = new IntersectionObserver(function (
    entries,
    observer
  ) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        // 当图片进入视口时
        const image = entry.target;
        const dataSrc = image.getAttribute("data-src");
        image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
        lazyLoadObserver.unobserve(image); // 停止观察该图片
      }
    });
  },
  config);

  images.forEach(function (image) {
    lazyLoadObserver.observe(image); // 开始观察每个图片
  });
}

function preloadImages(imageArray) {
  // 预加载
  // 检查数组数据结构
  if (Array.isArray(imageArray[0])) {
    // 处理二维数组
    imageArray.forEach((subArray) => {
      subArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    });
  } else {
    // 处理一维数组
    imageArray.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }
}

let spImgList1 = [
"https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-b1.jpg",
"https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-b2.jpg",
"https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-b3.png",
];

let spImgList = [
[
  "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-p1.png",
  "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-p2.png",
  "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-p3.png",
  "https://cdn.shopify.com/s/files/1/0567/3520/3402/files/20240526-p4.png",
],
];

document.addEventListener("DOMContentLoaded", function () {
  lazyLoadImages();

  preloadImages(spImgList1);
  preloadImages(spImgList);

  // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]');
  links.forEach(function (link) {
    link.addEventListener("click", function (event) {
      event.preventDefault(); // 阻止默认的跳转行为
      // var targetElement = document.getElementById('shopping');
      // if (targetElement) {
      //     targetElement.scrollIntoView({ behavior: 'smooth' });
      // } // 方式一
      const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
      const offsetTop = targetElement.offsetTop;
      window.scroll({
        top:
          offsetTop * $("div#root").css("zoom") +
          -255 * $("div#root").css("zoom"),
        behavior: "smooth", // 使用 smooth 实现平滑滚动
      }); // 方式二
    });
  });
});

// IOS字体多了间距的处理 给节点添加 sp_system 类名
// 判断当前用户是安卓端还是iOS端
var userAgent = navigator.userAgent || navigator.vendor || window.opera;
var isAndroid = /android/i.test(userAgent);
var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

if (isAndroid) {
  console.log("Android");
} else if (isIOS) {
  console.log("iOS");
} else if (isPC) {
  console.log("PC");
} else {
  $(".sp_system").css("letter-spacing", "-4px");
}


new Swiper("#swiper2", {
autoplay: true,
autoplay: {
  disableOnInteraction: false,
},
loop: true,
centeredSlides: true,
spaceBetween: -400,
slidesPerView: "auto",
pagination: {
  el: ".pagination1",
  type: "bullets",
  clickable: true,
},
});

let swiper = new Swiper("#sp-swiper-pro", {
// autoplay: true,
// autoplay: {
//   disableOnInteraction: false,
// },
// loop: true,
on: {
  slideChange: function (e) {
    $("#sp-color .option")
      .eq(e.activeIndex)
      .addClass("active")
      .siblings()
      .removeClass("active");
  },
},
navigation: {
  nextEl: ".swiper-btn-next",
  prevEl: ".swiper-btn-prev",
},
spaceBetween: 20,
});

let prods = window.product
console.log(prods)
function getCur() {
let color = $('#sp-color div.active').attr('data-val')
return prods.filter(item => item.option1 == color)[0]
}
function changePrice(){
let num = $('#calcNumber').val()
let price = (getCur().price / 100).toFixed(2)
let compare = (getCur().compare_at_price / 100).toFixed(2)
// if(num == 1){
//   price = (getCur().price * num / 100).toFixed(2)
// }else if(num == 2){
//   price = (getCur().price * num / 100 * 0.95).toFixed(2)
// }else if(num == 3){
//   price = (getCur().price * num / 100 * 0.9).toFixed(2)
// }else {
//   price = (getCur().price * num / 100 * 0.85).toFixed(2)
// }
// price = (price + '').replace('.', ',')
// compare = (compare + '').replace('.', ',')
$('.product-part .price-group .price1 span').html(price)
$('.product-part .price-group .price2 span').html(compare)
let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
$(".product-part .price-group .sp-off span").html(off_font);
}

$('.buyNow').click(function () {
let num = $('#calcNumber').val()
window.location.href = '/cart/' + getCur().id + ':' + num
})

$(".reduce").click(function () {
let input = $(this).siblings("input")[0];
let num = Number(input.value) - 1;
if (num > 0) {
  input.value = num;
}
});
$(".add").click(function () {
let input = $(this).siblings("input")[0];
let num = Number(input.value) + 1;
input.value = num;
});

$(".option").click(function () {
$(this).siblings().removeClass("active");
$(this).addClass("active");
// style选项
let colorOptions = $("#sp-color .option.active").index();
swiper.slideTo(colorOptions);
changePrice()
});
// 购物车加购动效
$(".cart-btn").click(function () {
$(this).children("img").addClass("on");
$(".sp-header-top .sp-cart .num").show();
setTimeout(function () {
  $(".cart-btn").children("img").removeClass("on");
}, 500);
$(".sp-header-top .sp-cart").addClass("on");
setTimeout(function () {
  $(".sp-header-top .sp-cart").removeClass("on");
}, 500);
});

window.cartCount > 0 ? $("#cardNum").removeClass("gray") : ''
$(".product-part .cart-btn").click(function () {
$('.c_toast').show()
setTimeout(function () {
  $('.c_toast').hide()
}, 1200);

var data = {
  id: getCur().id,
  quantity: $('#calcNumber').val(),
};

$.ajax({
  type: "POST",
  url: "/cart/add.js",
  data: data,
  success: function () {
    $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
      $("#cardNum").html(result.item_count);
      $("#cardNum").removeClass("gray")
    });
  },
  dataType: "json",
});

var img = $(".product-part  .swiper-slide-active .p-img");
var flyer = img[0].cloneNode(true);
flyer.classList.add("sp-clone");

$("#shopping").append(flyer);
$(".sp-clone").css({
  width: img[0].width,
  height: img[0].height,
  position: "fixed",
  top: img[0].offsetTop,
  left: img.offset().left,
  "z-index": "99",
});

let finish = $(".sp-cart");
$(".sp-clone").animate(
  {
    top: finish[0].offsetTop + $(".sp-nav-top").height(),
    left: finish[0].offsetLeft + finish.width() / 2,
    width: 50, // 结束时的大小，根据需要调整
    height: 50, // 结束时的大小，根据需要调整
    opacity: 0.4,
  },
  500,
  "linear",
  function () {
    $(this).animate(
      {
        width: 0,
        height: 0,
        opacity: 0,
      },
      0
    );
  }
);
});
